import { render, staticRenderFns } from "./exerciseDashboard.vue?vue&type=template&id=4983c412&"
import script from "./exerciseDashboard.vue?vue&type=script&lang=js&"
export * from "./exerciseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./exerciseDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports